import React, { useEffect, useRef, useState } from "react"
import ReactModal, {isOpen} from 'react-modal';
import { gsap, TweenLite, Power3 } from "gsap";
import "../../styles/styles.scss"
import HotspotButton from "./HotspotButton"
import Times from '../fa/Times';
import ArrowLeft from '../fa/ArrowLeft';
import ArrowRight from '../fa/ArrowRight';

gsap.registerPlugin(TweenLite);

const HotspotContainer = ({hotspot, order, hotspotType}) => {
    const [showModal, setShowModal] = useState(false);
    const [noNext, setNoNext] = useState(false);
    const [noPrev, setNoPrev] = useState(false);

    useEffect(()=> {
        const nextBtn = document.querySelector(`[data-id="${order+1}"]`);
        const prevBtn = document.querySelector(`[data-id="${order-1}"]`);
        if (nextBtn === null) {
            setNoNext(true)
        } 
        if (prevBtn === null) {
            setNoPrev(true) 
        }

    },[noNext, noNext])
    const pauseMedia = () => {
        const media = document.querySelectorAll("audio, video");
        media.forEach(item => {
          item.pause();
        })
    }
    const handleCloseModal = () => {
        // TweenLite.to(modalContainer, { opacity: 0,  duration: .5, ease:Power3.easeOut });
        pauseMedia();
        setShowModal(false);
    };
    const handleOpenModal = () => {
        setShowModal(true)
    };
    const openNextModal = () => {
        handleCloseModal();
        const nextBtn = document.querySelector(`[data-id="${order+1}"]`)
        if (nextBtn !== null) {
            nextBtn.firstElementChild.click();
        } 
    }
    const openPrevModal = () => {
        handleCloseModal();
        const prevBtn = document.querySelector(`[data-id="${order-1}"]`);
        if (prevBtn !== null) {
            prevBtn.firstElementChild.click();
        }
    }

    // Modal.setAppElement('main');
    
    return (
        <>
            <HotspotButton 
                handleOpenModal={handleOpenModal} 
                order={hotspot.maker ? "i" : hotspot.order} 
                btnTop={hotspot.btnTop} 
                btnLeft={hotspot.btnLeft}
            />
                <ReactModal 
                    onRequestClose={handleCloseModal}
                    isOpen={showModal}
                    contentLabel="Modal"
                    portalClassName="modal-container"
                    role="dialog"
                    className="Modal"
                    overlayClassName="Overlay"
                    ariaHideApp={showModal}
                    closeTimeoutMS={500}
                >
                
                <div className="navigation">
                    <button onClick={handleCloseModal} className="close primary-btn hidden">
                        <Times/>Close
                    </button>

                    {noPrev === true ?
                        <div></div> :
                        <button className="prev primary-btn"
                            onClick={openPrevModal}
                            ><ArrowLeft/>Previous
                        </button> 
                    }
                    {noNext === true ?
                        <div></div> :
                        <button className="next primary-btn"
                        onClick={openNextModal}
                        >Next<ArrowRight/>
                        </button> 
                    }
                </div>
                <div className="modal-content" aria-expanded={`${showModal}`}>{hotspotType}</div>
            </ReactModal>
        </>
    )
}

export default HotspotContainer;